//bilingual settings for language conversion
export const en = {
  items_per_page: "Article / Page",
  jump_to: "Jump to",
  jump_to_confirm: "Sure",
  page: "Page",
};
